// Assign to components with translations to make translation-related functionality 
// available
//
// Object.assign(SomeClass.prototype, ComponentHasTranslations);
// export default SomeClass

const ComponentHasTranslations = {
  // mixin to class
  tr: function(key) {
    return (
      this.props.tr[key] || `[${key}]`
    )
  },

  // for non-class components
  // returns a func that can be used like tr above, passing in translations
  tr_wrapper: (translations) => {
    return (key) => translations[key] || `[${key}]`
  }
}

export default ComponentHasTranslations;